@if (marginList.length) {
  <p-select
    [options]="marginList"
    [(ngModel)]="selectedMargin"
    (onChange)="onChange($event)"
    dataKey="id"
    placeholder="{{
      selectedMargin ? selectedMargin.getName() : 'Select Margin'
    }}"
  >
  </p-select>
}
